<template>
  <div style="background:#eee">
    <v-toolbar class="white--text gradient-blue">
      <img src="@/assets/logo.png" style="background: #fff;" height="46" alt="Ar-Risalah">
      <!--<v-btn-toggle class="ml-3" v-model="language" small mandatory>
        <v-btn small flat class="red white--text">IN</v-btn>
        <v-btn small flat class="cyan white--text">EN</v-btn>              
      </v-btn-toggle>-->     
      <!--<v-toolbar-title>TESTING !</v-toolbar-title>-->
      <v-spacer></v-spacer>
      <v-toolbar-title>
        <a :href="'tel:+'+$config.cp.wa" class="white--text"><v-icon class="yellow--text text--lighten-2">phone</v-icon> {{$config.cp.label}}</a>
      </v-toolbar-title>
      <v-list-tile>
        <v-list-tile-content>          
          <v-list-tile-title></v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>      
    </v-toolbar>     
    <section style="position:relative;">              
      <v-carousel :interval="!showcarousel?500:5000" height="530" hide-delimiters hide-controls>
        <v-carousel-item :lazy="true"
          v-for="(item,i) in carousels"
          :key="i"
          :src="item.src"
        ></v-carousel-item>            
      </v-carousel>
      <div style="background:rgba(0,0,0,0.2); width:100%; top:0px; position:absolute; display:none">
        <v-card style="border-radius:0 0 20px 0; margin-top: 0px; left:0px; position:absolute;" class="elevation-4 orange darken-2">
          <v-card-text>
            <span class="title white--text">#arrisalahKeren</span>                                               
          </v-card-text>
        </v-card>
        <!--<v-card style="border-radius:0 0 0 20px; margin-top: 0px; right:0px; position:absolute;" class="elevation-4">
          <v-card-text>
            <img src="@/assets/img/merk.jpg" height="80">                                                 
          </v-card-text>
        </v-card> -->
      </div> 
    </section>
    <section style="position:absolute; margin: auto; top:70px; left: 0; bottom:0; right: 0; ">                    
      <v-layout>
        <v-card class="transparent" elevation="0" style="margin-top">
          <v-card-text class="pl-4">
            <h1 style="line-height: 1; font-style:italic" class="mb-2"><strong style="font-size:40px; color:#003399;">PENERIMAAN PESERTA </strong> <strong style="font-size:45px; color:#003399">DIDIK</strong> <strong style="font-size:44px; color:#E4D318; -webkit-text-stroke: 2px black; font-weight:1000; "> BARU </strong></h1>
            <img src="@/assets/img/tahunajaran.jpg" style="border-radius:5px; width:100%; max-width:350px" />
            <h1 style="line-height: 1; font-style:italic; display:none">
              <strong style="font-size:50px; color:#0A8046; -webkit-text-stroke: 2px white; font-weight:900; ">SD-Qu</strong>
              <strong style="font-size:50px; color:#0A8046; -webkit-text-stroke: 2px white; font-weight:900; ">SMP . </strong>
              <strong style="font-size:50px; color:#0A8046; -webkit-text-stroke: 2px white; font-weight:900; ">MA </strong>
            </h1>
            <h1 class="mt-2"><span style="color:#1B5E10">PERGURUAN ISLAM</span> <strong style="color:#28336A"> AR RISALAH</strong></h1>
          </v-card-text>
          <v-card-text class="pa-0 pb-0">
            <v-container grid-list-lg>
              <v-layout row wrap>
                <!--<v-flex xs12 class="white"><h1 class="text-center display-1 black--text">Coming Soon...</h1></v-flex>-->
                <v-flex xs6>
                  <v-card dark :to="{name:'register'}" class="grey white--text" style="border-radius:10px 0 0 10px">
                    <v-card-text class="text-xs-center pa-1">
                      <v-icon size="40">how_to_reg</v-icon><br/>
                      <strong> {{language ? 'register now':'Daftar sekarang'}}</strong>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs6 >
                  <v-card dark :to="{name:'login'}"  class="green white--text" style="border-radius:0px 10px 10px 0px ">
                    <v-card-text class="text-xs-center pa-1">
                      <v-icon size="40">policy</v-icon><br/>
                      <strong>{{language ? 'login':'Masuk'}}</strong>
                    </v-card-text>
                  </v-card>
                </v-flex>                
              </v-layout>    
            </v-container>
          </v-card-text>  
          <v-card-text class="pt-0">
            <v-alert type="warning" class="pa-2 mx-1" value="true">
              <p class="mb-0" style="font-size:17px">Pendaftaran PPDB untuk tingkat SD, SMP dan MA telah <strong>ditutup</strong>.<br/> Info lebih lanjut silahkan hubungi admin kami. Terima kasih</p>
              <!--<p class="mb-0">Info : Pendaftaran untuk SMP Arrisalah 2 Air Pura Pesisr Selatan telah dibuka, kunjungi link <a class="yellow--text" href="https://ppdb2.arrisalah.sch.id" target="_blank">https://ppdb2.arrisalah.sch.id</a> untuk pendaftaran.</p>-->
            </v-alert>
          </v-card-text>        
        </v-card>
      </v-layout> 
      <v-layout column style="align-items: center; justify-content: center; text-align: center; display:none">
        <v-card class="mx-2" style="margin-top:10vh !important; background:rgba(255,255,255,0.8); color:#273163; border-radius:10px">
          <v-card-text class="text-xs-center pa-4">
            <h1 class="text-xs-center" style="text-align:center !important"><span style="color:#1B5E10">PERGURUAN ISLAM</span> AR RISALAH</h1>
            <h1 class="text-xs-center mb-3 black--text" style="text-align:center !important; font-size:20px">Sumatera Barat</h1>
            <h1 style="font-size:25px"><strong>PENERIMAAN PESERTA DIDIK BARU</strong></h1>
            <h1 style="font-size:35px"><span style="color:#fff; padding:0 10px; background:#f57c00; border-radius:10px">PPDB</span>&nbsp;<span style="color:#19432F">2023-2024</span></h1>
            <v-chip @click="$router.push({path:'/register',query:{tingkat_id:1}})" color="red" dark ><span class="subheading">SD</span></v-chip>
            <v-chip @click="$router.push({path:'/register',query:{tingkat_id:2}})" color="indigo" dark ><span class="subheading">SMP</span></v-chip>
            <v-chip @click="$router.push({path:'/register',query:{tingkat_id:3}})" color="blue-grey" dark ><span class="subheading">MA</span></v-chip>
          </v-card-text>
          <v-card-text class="pa-0">
            <v-container grid-list-lg>
              <v-layout row wrap>
                <!--<v-flex xs12 class="white"><h1 class="text-center display-1 black--text">Coming Soon...</h1></v-flex>-->
                <v-flex xs6>
                  <v-card :to="{name:'register'}" class="blue--text" style="border-radius:10px 0 0 10px">
                    <v-card-text class="text-xs-center pa-1">
                      <v-icon size="40" color="blue">how_to_reg</v-icon><br/>
                      <strong> {{language ? 'register now':'daftar sekarang'}}</strong>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs6 >
                  <v-card :to="{name:'login'}"  class="green--text" style="border-radius:10px 10px 10px 10px ">
                    <v-card-text class="text-xs-center pa-1">
                      <v-icon size="40" color="green">policy</v-icon><br/>
                      <strong>{{language ? 'login':'masuk'}}</strong>
                    </v-card-text>
                  </v-card>
                </v-flex>                
              </v-layout>    
            </v-container>
          </v-card-text>
          <v-card-text class="pt-0 px-4">
            <v-alert color="primary" value="true">
              Pendaftaran SD.Qu telah dibuka.
            </v-alert>
          </v-card-text>
        </v-card>                              
             
        <!--<v-layout row wrap class="my-3" style="margin-top:30vh !important;">
          <v-flex xs12 class="text-xs-center">
            <h1 class="text-xs-center display-2 yellow--text"><strong>{{ language ? 'ACCEPTANCE':'PENERIMAAN' }}</strong></h1>
            <h1 class="text-xs-center headline yellow--text mb-2"><strong>{{ language ? 'OF NEW STUDENTS (PPDB)':'PESERTA DIDIK BARU (PPDB)'}}</strong></h1>
            <span class="text-xs-center title yellow indigo--text"><strong>{{ language ? 'SCHOOL YEAR ':'TAHUN AJARAN'}} 2023/2024</strong></span>
          </v-flex>
          <v-flex xs12 class="text-xs-center my-3">
            <v-chip @click="$router.push({path:'/register'})" color="red" dark ><span class="subheading">SD</span></v-chip>
            <v-chip @click="$router.push({path:'/register'})" color="indigo" dark ><span class="subheading">SMP</span></v-chip>
            <v-chip @click="$router.push({path:'/register'})" color="blue-grey" dark ><span class="subheading">MA</span></v-chip>
          </v-flex>
          <v-flex xs12 class="text-xs-center my-3">  
            <v-btn
              class="mb-2 red lighten-1 white--text"                
              medium
              href="#/register"
            >
              <v-icon left>how_to_reg</v-icon> {{language ? 'REGISTER NOW (SD)':'DAFTAR BARU (SD)'}}
            </v-btn>
            <v-btn medium class="cyan" dark href="#/login">{{language ? 'LOGIN':'MASUK'}}</v-btn>
            
          </v-flex>                               
        </v-layout>
        <v-layout row wrap>
          <v-btn
            class="mb-2 pink lighten-1 white--text"                
            medium
            href="#/register"
          >
            <v-icon left>how_to_reg</v-icon> {{language ? 'REGISTER NOW':'DAFTAR BARU'}}
          </v-btn>
          <v-btn medium class="cyan" dark href="#/login">{{language ? 'LOGIN':'MASUK'}}</v-btn>
        </v-layout> 
        <v-alert type="warning" class="text-xs-center" value="true">
          <h3>Mohon Maaf, Observasi untuk pendaftar SDQu ditunda sampai waktu yang belum ditentukan.</h3>
        </v-alert>
        <v-alert type="purple" class="text-xs-center" value="true">
          <h3>Pendaftaran PPDB untuk tingkat MA, SMP & SDQu telah <strong>ditutup</strong>. Terima kasih.</h3>
        </v-alert>-->                             
      </v-layout> 
    </section>   
    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center        
      >
        <v-layout column  align-center justify-center class="white--text" style="position:relative">
          <img src="@/assets/img/monitor-white.png" style="width:100%; max-width: 600px;" alt="Vuetify.js">
          <!--<iframe class="iframetv" src="https://www.youtube.com/embed/x2Yg6K-sxgw" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->          
          <iframe class="iframetv" src="https://www.youtube.com/embed/DszwMouLD-M" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                    
        </v-layout>
        <v-flex xs12 sm4 class="mt-3">
          <div class="text-xs-center">
            <h2 class="headline pink--text mb-3"><strong>{{language ? 'The realization of a Generation of Blessing that is, Qur\'ani, Character and Achievement':'Terwujudnya Generasi Penuh Berkah yang, Qur\'ani, Berkarakter dan Berprestasi'}}</strong></h2>
            <span class="subheading indigo--text">
              {{language ? 'The Best Way to Start Boarding School':'The Best Way to Start Boarding School'}}
            </span>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-container grid-list-md>
            <v-layout row wrap align-center>
              <v-flex xs6 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="blue--text text--lighten-2">local_library</v-icon><br/>
                    <span> <strong>Qur'ani</strong> -
                    {{language ? 'Optimizing the religious potential of students in the education process':'Mengoptimalkan potensi religius siswa dalam proses pendidikan'}}
                    </span>
                  </v-card-text>                                   
                </v-card>
              </v-flex>
              <v-flex xs6 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="red--text text--lighten-2">accessibility_new</v-icon><br/>
                    <strong>{{language ? 'Character Building':'Berkarakter'}}</strong> - 
                    {{language ? 'Create a character-based learning process':'Mewujudkan proses pembelajaran berbasis karakter'}}
                  </v-card-text>                                    
                </v-card>
              </v-flex>
              <v-flex xs12 md4>
                <v-card class="elevation-0 transparent">
                  <v-card-text class="text-xs-center">
                    <v-icon x-large class="orange--text text--lighten-2">wb_incandescent</v-icon><br/>
                    <strong>{{language ? 'Achievement':'Berprestasi'}}</strong> - 
                    {{language ? 'Strive for learning with maximum learning results':'Mengupayakan pembelajaran dengan hasil belajar maksimal'}}
                  </v-card-text>                                    
                </v-card>
              </v-flex>              
            </v-layout>
          </v-container>
        </v-flex>
        <v-divider></v-divider>
        <v-flex xs12 lg10>
          <v-card class="ma-3" style="max-width:850px">
            <v-toolbar color="gradient-blue" dark dense cad>
              <v-toolbar-title>{{language ? 'Registration Procedure':'Prosedur Pendaftaran'}}</v-toolbar-title>
            </v-toolbar>            
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md4>                  
                  <v-btn :href="$config.url+'cdn/file/brosurSD.pdf'" target="_blank" outline block color="error">Download Brosur SD</v-btn>
                </v-flex>
                <v-flex xs12 md4>
                  <v-btn :href="$config.url+'cdn/file/brosurSMP.pdf'" target="_blank" outline block color="primary">Download Brosur SMP</v-btn>
                </v-flex>
                <v-flex xs12 md4>                  
                  <v-btn :href="$config.url+'cdn/file/brosurMA.pdf'" target="_blank" outline block color="blue-grey" dark>Download Brosur MA</v-btn>
                </v-flex>                
              </v-layout>
            </v-card-text>
            <v-card-text>
              <h3 class="mb-2"><v-icon>calendar_today</v-icon> {{language ? 'Registration Schedule':'Jadwal Pendaftaran'}}</h3>
              <v-divider class="mb-2"></v-divider>
              <p class="caption mb-4">
                <strong>Timeline Pendaftaran PPDB SMP 2023/2024: </strong>
                <ul>
                  <li>Jalur Undangan Tanggal 19 September 2022 s/d 2 Oktober 2022</li>
                  <li>Prestasi Tahap I Tanggal 9 September 2022 s/d 8 Oktober 2022</li>
                  <li>Reguler Tahap I Tanggal 9 September 2022 s/d 10 November 2022</li>
                  <li>Tes Qur’an Tahap I Tanggal 9 September s/d 10 November 2022</li>
                  <li>Tes Akademik Tahap I Tanggal 13 November 2022</li>
                </ul>
                <ul class="mt-2">
                  <li>Prestasi Tahap II Tanggal 14 November 2022 s/d 18 Desember 2022</li>
                  <li>Reguler Tahap II Tanggal 14 November 2022 s/d 23 Desember 2022</li>
                  <li>Tes Qur’an Tahap II Tanggal 14 November s/d 25 Desember 2022</li>
                  <li>Tes Akademik Tahap II Tanggal 25 Desember 2022</li>
                </ul>
              </p>
              <p class="caption mb-4">
                <strong>Timeline Pendaftaran PPDB MA 2023/2024: </strong>
                <ul>
                  <li>Prestasi Tanggal 9 September 2022 s/d  7 Januari 2023</li>
                  <li>Reguler Tanggal 9 September 2022 s/d 22 Februari 2023</li>
                  <li>Tes Qur’an Tanggal 9 September s/d 22 Februari 2023</li>
                  <li>Tes Akademik Tanggal 25 Februari 2023</li>
                </ul>                 
              </p>  
              <h3 class="mb-2"><v-icon>file_copy</v-icon> {{language ? 'Test Material':'Materi Ujian'}}</h3>
              <v-divider class="mb-2"></v-divider>
              <p class="caption mb-4">
                <ul>
                  <li>{{language ? 'Al-Quran test during registration / throughout the registration schedule':'Tes Al-Quran saat pendaftaran / sepanjang jadwal pendaftaran'}}</li>
                  <li>{{language ? 'Writing Examination Material':'Materi Ujian Tulis'}}
                    <ul>
                      <li>{{language ? 'SD : (no test)':'SD : (tidak ada tes)'}}</li>
                      <li>{{language ? 'SMP : Mathematics, Natural Sciences, Islamic Education, and Psychology':'SMP : Matematika, IPA, PAI, dan psikotest'}}</li>
                      <li>{{language ? 'MA majors:': 'MA perjurusan :'}}
                        <ul>
                          <li>IPA : Matematika, Bahasa Inggris, IPA Terpadu</li>
                          <li>IPS : Matematika, Bahasa Inggris, IPS Terpadu</li>
                          <li>AGAMA : Matematika, Bahasa Inggris, Bahasa Arab</li>
                        </ul> 
                      </li>  
                    </ul>
                  </li>
                  <!--<li>{{language ? 'Parent\'s interview during a written exam':'Wawancara orang tua pada saat anak ujian tulis'}}</li>-->
                </ul>
              </p>
              <h3 class="mb-2"><v-icon>post_add</v-icon> {{language ? 'Registration requirement':'Syarat Pendaftaran'}}</h3>
              <v-divider class="mb-2"></v-divider>
              <ol class="caption">
                <!--<li>Satu eksemplar fotocopi [Rapor SD kelas III s.d V (pendaftar SMP)] atau [Rapor SMP kelas VII s.d IX (pendaftar SMA)] </li>-->
                <li>{{language ? 'soft copy of a 3x4 color photo (* hijab required)':'Softcopy pasfoto berwarna 3x4 (*putri berjilbab)'}}</li>
                <li>{{language ? 'sofcopy of the latest educational report':'Mengupload blanko rapor pendidikan terakhir (kelas 4 & 5 untuk pendaftar SMP, kelas 7 & 8 untuk pendaftar MA) 1 rangkap'}}</li>
                <li>{{language ? 'Soctcopy Akta Kelahiran khusus untuk pendaftar SD':'Scan Akta Kelahiran khusus untuk pendaftar SD'}}</li>
                <li>{{language ? 'Paying registration fee IDR 100,000 for SD or IDR 200,000 for SMP and IDR 250,000 for MA':'Membayar uang pendaftaran Rp.250.000,- untuk SMP dan Rp.300.000,- untuk MA jalur Reguler'}}</li>
                <li>{{language ? 'Fill in the registration form':'Mengisi formulir pendaftaran online'}}</li>
                <li>{{language ? 'Scan OSN / MHQ / Tahfidz champion certificate (* specifically for achievement track for SMP/MA)':'Scan sertifikat juara OSN/MHQ/Tahfidz (*khusus jalur prestasi untuk SMP/MA)'}}</li>
              </ol>
            </v-card-text>
            <v-card-text>
              <h3 class="mb-2"><v-icon>thumb_up</v-icon> {{'Jalur Prestasi'}}</h3>
              <v-divider class="mb-2"></v-divider>
              <v-layout row wrap>
                <v-flex xs12>
                  <p>
                  <strong>A. Prestasi Kategori A</strong><br/>
                  (kuota terbatas)
                  </p>
                  <p class="mb-0 caption">
                   Benefit :
                    <ol>
                      <li>Bebas Biaya Pendaftaran</li>
                      <li>Bebas biaya pembangunan 10 jt</li>
                      <li>Tidak wajib membayar “Qardh Al Hasan” 2 jt</li>
                      <li>SPP full beasiswa selama 3 tahun</li>
                    </ol>                  
                  </p>
                  <p class="mb-0 caption">
                    Kriteria :
                    <ol>
                      <li>Juara 1,2 dan 3 OSN/KSN/KSM tingkat nasional</li>
                      <li>Hafizh 30  juz lulus tes oleh penguji Ar Risalah</li>
                      <li>Juara 1,2 dan 3 MHQ tingkat nasional</li>
                    </ol>    
                  </p>
                  <p class="caption">
                    Ketentuan:
                    <ol>
                      <li>MoU menamatkan pendidikan di PIAR</li>
                      <li>Tidak melakukan pelanggaran berat</li>
                      <li>Sungguh-sungguh dalam belajar (standar KKM/naik kelas)</li>
                      <li>Mempertahankan hafalan 30 Juz ( saat wisuda 30 juz, tidak lagi mendapat beasiswa 30 juz)</li>
                    </ol>
                  </p>
                </v-flex>
                <v-flex xs12>
                  <p>
                    <strong>B. Prestasi Kategori B</strong><br/>
                    (kuota terbatas)
                  </p>
                  <p class="mb-0 caption">
                    Benefit:
                    <ol>
                      <li>Bebas biaya pendaftaran</li>
                      <li>Potongan biaya pembangunan 50% (5 jt)</li>
                      <li>Tidak wajib membayar Qardh Al Hasan (2 jt)</li>                      
                    </ol>
                  </p>
                  <p class="mb-0 caption">
                    Kriteria:
                    <ol>
                    <li>Juara 1,2 dan 3 OSN TingkatProvinsi/KSM/Perwakilan provinsi </li>
                    <li>Hafizh 20  juz untuk masuk MA, dan 10 juz untuk masuk SMP (lulus tes oleh penguji ar risalah)</li>
                    <li>Juara 1,2 dan 3 MHQ tingkat provinsi/utusan provinsi ke nasional</li>
                    </ol>
                  </p>  
                  <p class="mb-0 caption">
                    Ketentuan :
                    <ol>
                    <li>MoU menamatkan pendidikan di PIAR</li>
                    <li>Tidak melakukan pelanggaran berat.</li>
                    <li>Sungguh-sungguh dalam belajar (standar KKM/naik kelas) </li>
                    </ol>
                  </p>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </section>

    <!--<section>
      <v-parallax :src="require('@/assets/img/banner-3.jpg')" height="400" style="padding:0px 0px">
        <v-layout column align-center justify-center style="background:rgba(0,0,0,0.3); margin:0px -13px">                                    
          <div class="swiper-container" style="overflow-x:auto;">                
            <div class="swiper-wrapper timeline" style="min-width:850px">
              <template v-if="language">
                <div class="swiper-slide" v-for="item in stepsEn">
                  <div class="timestamp">
                    <span class="yellow--text"><strong>{{item.dateLabel}}</strong></span>
                  </div>
                  <div class="status">
                    <span class="white--text">{{item.title}}</span>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="swiper-slide" v-for="item in steps">
                  <div class="timestamp">
                    <span class="yellow--text"><strong>{{item.dateLabel}}</strong></span>
                  </div>
                  <div class="status">
                    <span class="white--text">{{item.title}}</span>
                  </div>
                </div>
              </template>              
            </div>                                
          </div>                                
        </v-layout>
      </v-parallax>
    </section>-->

    <section class="gradient-blue">
      <v-container grid-list-xl>
        <v-layout row wrap justify-center class="my-1">
          <v-flex xs12 sm4>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline blue--text">{{language ? 'Best Boarding School':'Pesantren Terbaik'}}</div>
              </v-card-title>
              <v-card-text class="span label py-0 white--text">
                {{language ? 'The strategic and conducive location of Ar-Risalah and well-ordered buildings and facilities are ideal for supporting an effective and enjoyable learning process. With a boarding system, the process of seeding Islamic teachings will be internalized more quickly into the souls of students.':'Lokasi Ar-Risalah yang stategis dan kondusif serta bangunan dan fasilitas yang tertata dengan baik, sangat ideal untuk menunjang proses pembelajaran yang efektif dan menyenangkan. Dengan sistem boarding maka proses penyemaian ajaran Islam akan lebih cepat terinternalisasikan ke dalam jiwa santriwan/ti. '}}                
              </v-card-text>
              <v-card-text class="pb-0 white--text">
                <span>{{language ? 'powered by :' :'dipersembahkan oleh :'}} </span><br/>                
                <img class="mt-2" style="border-radius:10px;" src="@/assets/img/yayasan.png" height="50">                                
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm4 offset-sm1>
            <v-card class="elevation-0 transparent">
              <v-card-title primary-title class="layout justify-center">
                <div class="headline blue--text">{{language ? 'Contact us':'Hubungi Kami'}}</div>
              </v-card-title>
              <v-card-text class="white--text py-0">
                Air Dingin RT.01 RW.IX Kel.Balai Gadang, Kec.Koto Tangah,
                Padang, Sumatera Barat
              </v-card-text>              
              <v-list class="transparent">               
                <v-list-tile>
                  <v-list-tile-action>
                    <a target="_blank" href="https://www.google.com/maps/search/?api=1&query=-0.828435,100.391211"><v-icon class="yellow--text text--lighten-2">place</v-icon></a>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <a target="_blank" href="https://www.google.com/maps/search/?api=1&query=-0.828435,100.391211"><v-list-tile-title class="">Lubuk Minturun, Padang</v-list-tile-title></a>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon class="yellow--text text--lighten-2">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title class="white--text">humaspiar@gmail.com</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>  
                <v-list-tile>
                  <v-list-tile-action>
                    <a class="white--text" target="_blank" href="https://id-id.facebook.com/HumasPIAR/"><img :src="require('@/assets/img/facebook.png')" style="height:25px" /></a>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <a class="white--text" target="_blank" href="https://id-id.facebook.com/HumasPIAR/">Humas Ar Risalah</a>
                  </v-list-tile-content>
                </v-list-tile>                  
                <template v-for="(cp, i) in narahubung">
                  <v-list-tile class="mb-2" :key="i">
                    <!--<v-list-tile-action>
                      <a :href="'tel:08116655980'"><v-icon class="yellow--text text--lighten-2">phone</v-icon></a>
                    </v-list-tile-action> -->
                    <v-list-tile-action>
                      <a target="_blank" :href="'https://api.whatsapp.com/send?phone='+cp.wa"><img :src="require('@/assets/img/waicon.png')" style="height:25px" /></a>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <a :href="'tel:+'+$config.cp.wa" class=""> {{cp.label}} <br/><small>({{cp.name}})</small></a>                    
                    </v-list-tile-content>
                  </v-list-tile>         
                </template>       
              </v-list>                             
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>   
  </div>
</template>

<script>

  
  export default {
    name: 'helloworld',  
    data: () => ({
      language:0,
      showcarousel:false,
      model : {
        username : null,
        password : null,
        captcha  : null
      },
      steps : [
        { dateLabel: 'Sept - Des 2019', title: 'Jadwal Pendaftaran' },
        { dateLabel: 'Jan - Feb 2023', title: 'Ujian Tulis SMP & MA'},
        { dateLabel: 'Feb - Mar 2023', title: 'Pengumuman Hasil' },
        { dateLabel: 'Maret 2023', title: 'Pendaftaran Ulang' },        
      ],
      stepsEn : [
        { dateLabel: 'Sept - Dec 2019', title: 'Registration Schedule' },
        { dateLabel: 'Jan - Feb 2019', title: 'Write Examination of SMP & MA' },
        { dateLabel: 'Feb - Mar 2023', title: 'announcement of results' },
        { dateLabel: 'Maret 2023', title: 're-registration' },        
      ],
      carousels: [      
          {
            src: require('@/assets/img/carousel/6.jpg')
          },    
          /*{
            src: require('@/assets/img/carousel/1.jpg')
          },
          /*{
            src: require('@/assets/img/carousel/2.jpg')
          },
          /*{
            src: require('@/assets/img/carousel/3.jpg')
          },
          {
            src: require('@/assets/img/carousel/4.jpg')
          },*/
          
        ],
        narahubung:[
          {
            wa:'6282169815584',
            label:'0821-6981-5584',
            name:'WAFI'
          },
          {
            wa:'6282285301615',
            label:'0822-8530-1615',
            name:'RAFIF'
          },
          /*{
            wa:'6282382578417',
            label:'0823-8257-8417',
            name:'Ustadzah Dina'
          },
          {
            wa:'6285264280049',
            label:'0852-6428-0049',
            name:'Ustadzah Kurnia Anessa'
          },
          {
            wa:'6285256523418',
            label:'0852-5652-3418',
            name:'Ustadzah Agusela'
          }*/
        ]         
    }),
    mounted(){
      setTimeout(()=>{this.showcarousel = true;},1000);
    }
  }
</script>

<style scoped>  
a{
  color:white
}
.v-window__container{
  height:100vh !important;
}
.iframetv{
    position:absolute; top:20px; width:95%; max-width:560px; height:320px;
}
@media only screen and (max-width: 600px) {
  .iframetv{
    position:absolute; top:13px; width:92%; max-width:560px; height:210px
  }
}
.timeline {
  margin: 50px 0;
  list-style-type: none;
  display: flex;
  padding: 0;
  text-align: center;
}
.timeline li {
  transition: all 200ms ease-in;
}
.timestamp {
  width: 350px;
  margin-bottom: 20px;
  padding: 0px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 100; 
}
.status {
  padding: 0px 40px;
  display: flex;
  justify-content: center;
  border-top: 10px solid yellow;
  position: relative;
  transition: all 200ms ease-in ;
}
  
.status span {
  font-weight: 600;
  padding-top: 20px;
}
.status span:before {
  content: '';
  width: 25px;
  height: 25px;
  background-color: #e8eeff;
  border-radius: 25px;
  border: 4px solid #3e70ff;
  position: absolute;
  top: -15px;
  left: 42%;
  transition: all 200ms ease-in;
}
.swiper-control {
  text-align: right;
}

.swiper-container {
  width: 100%;
  height: 250px;
  margin: 0px 0;
  overflow: hidden;
  padding: 0 20px 30px 20px;
}
.swiper-slide {
  width: 300px;
  text-align: center;
  font-size: 18px;
}
.swiper-slide:nth-child(2n) {
  width: 40%;
}
.swiper-slide:nth-child(3n) {
  width: 20%;
}
.gradient-blue{
  background:linear-gradient(92.3deg, #0C3808 4.98%, #386F0C 74.5%) !important
}

</style>
